import { THEME_ID, ThemeDefinition, ThemeId } from './types';
import { kindlyTheme } from './kindly-theme';
import { kindlyChristianTheme } from './kindly-christian';

export type { ThemeDefinition, ThemeId, ThemeColors } from './types';

const THEMES: Record<ThemeId, ThemeDefinition> = {
  [THEME_ID.KINDLY]: kindlyTheme,
  [THEME_ID.KINDLY_CHRISTIAN]: kindlyChristianTheme,
};

const DOMAIN_THEME_MAP: Record<string, ThemeId> = {
  'kindlyhuman.io': THEME_ID.KINDLY,
  'kindlychristian.io': THEME_ID.KINDLY_CHRISTIAN,
  'kindlychristian.dev.lis-call.com': THEME_ID.KINDLY_CHRISTIAN,
  'kindlychristian.stage.lis-call.com': THEME_ID.KINDLY_CHRISTIAN,
  localhost: THEME_ID.KINDLY,
};

export function resolveTheme(): ThemeDefinition {
  const envOverride = process.env.REACT_APP_THEME_OVERRIDE as ThemeId | undefined;
  if (envOverride && (envOverride === THEME_ID.KINDLY || envOverride === THEME_ID.KINDLY_CHRISTIAN)) {
    return THEMES[envOverride];
  }

  const hostname = window.location.hostname;

  const exactMatch = DOMAIN_THEME_MAP[hostname];
  if (exactMatch) {
    return THEMES[exactMatch];
  }

  const suffixMatch = Object.entries(DOMAIN_THEME_MAP).find(([domain]) => hostname.endsWith(`.${domain}`));
  if (suffixMatch) {
    return THEMES[suffixMatch[1]];
  }

  return THEMES.kindly;
}

export function getThemeById(id: ThemeId): ThemeDefinition {
  return THEMES[id];
}

export function applyThemeToDocument(theme: ThemeDefinition): void {
  const root = document.documentElement;
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });
}
